import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const facebookMessenger = defineConnector({
  identifier: "facebookMessenger",
  name: "Facebook Messenger",
  tagLine: "Messenger platform APIs",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://graph.facebook.com/.*",
  auth: (app) =>
    queryAuth([
      {
        name: "access_token",
        value: app.secret.pageAccessToken,
      },
    ]),
  steps: [
    {
      title: "Create a Page access token",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://developers.facebook.com/docs/messenger-platform/reference/send-api/](https://developers.facebook.com/docs/messenger-platform/reference/send-api/) to create a Page access token. Meta's Send API examples pass that credential as the `access_token` request parameter.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "input",
          label: "Page access token",
          required: true,
          target: {
            kind: "secrets",
            field: "pageAccessToken",
          },
        },
        {
          kind: "input",
          label: "Graph API version",
          placeholder: "v23.0",
          target: {
            kind: "configuration",
            field: "version",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://graph.facebook.com/",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod, ...configuration }) => ({
      url:
        testUrl ??
        (({ version = "v23.0" }) =>
          `https://graph.facebook.com/${version}/me?fields=id,name`)(
          configuration
        ),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
